class Stats {
    constructor() {
        this.selector = '.syn-stats .stat-item[data-animate="yes"]';
        this.collection = [];
        
        this.init();
    }

    init() {
        const elements = document.querySelectorAll(this.selector);
        
        elements.forEach(element => {
            this.collection.push(new StatItem(element));
        });
    }
}

class StatItem {
    constructor(element) {
        this.element = element;
        this.counter = this.element.querySelector('.number');
        this.start = this.parseNumber(this.element.getAttribute('data-start'));
        this.end = this.parseNumber(this.element.getAttribute('data-end'));
        this.count = this.start;
        this.duration = 1300;
        this.step = this.parseNumber(this.element.getAttribute('data-step'));
        this.animationTiming = 13;
        this.interval;

        this.init();
    }

    parseNumber(value) {
        if (value === null || value === undefined || value === '') {
            return 0;
        }

        const cleaned = String(value).replace(/,/g, '').trim();
        const parsed = Number(cleaned);

        return Number.isFinite(parsed) ? parsed : 0;
    }

    formatNumber(value, decimals = 0) {
        return Number(value).toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }

    init() {
        // wait for the element to be in view
        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.animate();
                observer.unobserve(entry.target);
            }
            });
        }, { rootMargin: '0px 0px -200px 0px' });

        this.observer.observe(this.element);
    }

    get type() {
        if ( 
            this.start % 1 !== 0 || 
            this.end % 1 !== 0 ||
            this.step % 1 !== 0
        ) {
            return 'fractional';
        } else {
            if ( this.start < 0 || this.end < 0 ) {
                return 'negative';
            } else {
                return 'positive';
            }

        }
    }

    get direction() {
        if ( this.start > this.end ) {
            return 'down';
        } else {
            return 'up';
        }
    }

    animate() {
        switch (this.type) {
            case 'negative':
                this.interval = setInterval(() => {
                    if (this.direction === 'down') {
                        this.count += this.step;
                        this.counter.textContent = this.formatNumber(this.count);

                        if (this.count < this.end) {
                            this.counter.textContent = this.formatNumber(this.end);
                            clearInterval(interval);
                        }
                    } else {
                        this.count = this.count - this.step;
                        this.counter.textContent = this.formatNumber(this.count);

                        if (this.count > this.end) {
                            this.counter.textContent = this.formatNumber(this.end);
                            clearInterval(this.interval);
                        }
                    }
                }, this.animationTiming);
                break;

            case 'positive':
                this.interval = setInterval(() => {
                    if (this.direction === 'down') {
                        this.count -= this.step;
                        this.counter.textContent = this.formatNumber(this.count);
                        
                        if (this.count < this.end) {
                            this.counter.textContent = this.formatNumber(this.end);
                            clearInterval(this.interval);
                        }
                    } else { 
                        this.count += this.step;
                        this.counter.textContent = this.formatNumber(this.count);

                        if (this.count > this.end) {
                            this.counter.textContent = this.formatNumber(this.end);
                            clearInterval(this.interval);
                        }
                    }
                }, this.animationTiming);
                break;    

                
            case 'fractional':
                this.interval = setInterval(() => {
                    if (this.direction === 'down') {
                        this.count -= this.step;
                        this.counter.textContent = this.formatNumber(this.count, 2);
                        
                        if (this.count < this.end) {
                            this.counter.textContent = this.formatNumber(this.end, 2);
                            clearInterval(this.interval);
                        }
                    } else { 
                        this.count += this.step;
                        this.counter.textContent = this.formatNumber(this.count, 2);

                        if (this.count > this.end) {
                            this.counter.textContent = this.formatNumber(this.end, 2);
                            clearInterval(this.interval);
                        }
                    }
                }, this.animationTiming);
                break;    
        
            default:
                break;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.synapse = window.synapse || {};
    
    window.synapse.CounterBadges = new Stats();
});